import Vue from 'vue'
import { safariJS } from './safari'

import { Uploader, Field, Cell, CellGroup, Form, Popup, Picker, Button, Icon, Toast, Collapse, CollapseItem, CheckboxGroup, Checkbox, CountDown, Calendar, DatetimePicker, Dialog } from 'vant'
import { Image as VanImage } from 'vant';
import 'vant/lib/index.css';

export default () => {
  
  safariJS(document, window)
  Vue.use(Uploader);
  Vue.use(Form);
  Vue.use(Field);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(Popup);
  Vue.use(Picker);
  Vue.use(Button);
  Vue.use(Icon);
  Vue.use(Toast);
  Vue.use(Collapse);
  Vue.use(CollapseItem);
  Vue.use(CheckboxGroup);
  Vue.use(Checkbox);
  Vue.use(VanImage);
  Vue.use(CountDown);
  Vue.use(Calendar);
  Vue.use(DatetimePicker);
  Vue.use(Dialog);
}